export const pathnames = {
    '/': {},
    '/about-us': {
        lv: '/par-mums',
        lt: '/apie-mus'
    },
    '/contact-us': {
        lv: '/kontakti',
        lt: '/kontaktai'
    },
    '/sustainability': {
        lv: '/ilgtspeja',
        lt: '/tvarumas'
    },
    '/forest-management': {
        lv: '/meza-apsaimniekosana',
        lt: '/misku-valdymas'
    },
    '/logging': {
        lv: '/mezizstrade',
        lt: '/medienos-ruosa'
    },
    '/timber-industry': {
        lv: '/kokrupnieciba',
        lt: '/medienos-produktai'
    },
    '/energy': {
        lv: '/energija',
        lt: '/energija'
    },
    '/transport-and-logistics': {
        lv: '/transports-un-logistika',
        lt: '/transportavimas-ir-logistika'
    },
    '/sawn-wood-trade': {
        lv: '/zagmaterialu-tirdznieciba',
        lt: '/pjautines-medienos-prekyba'
    },
    '/round-timber-trade': {
        en: '/log-trade',
        cn: '/log-trade',
        lv: '/apalkoku-tirdznieciba',
        lt: '/apvaliosios-medienos-prekyba'
    },
    '/financing': {
        lv: '/finansesana',
        lt: '/finansavimas'
    },
    '/privacy-policy': {
        lv: '/privatuma-politika',
        lt: '/privatumo-politika'
    },
    '/whistleblowing-policy': {
        lv: '/trauksmes-celsanas-politika',
        lt: '/apie-mus'
    },
    '/code-of-conduct': {
        lv: '/pata-etikas-kodekss',
        lt: '/pata-elgesio-kodeksas'
    },
    '/impact-on-the-environment': {
        lv: '/ietekme-uz-vidi',
        lt: '/poveikis-aplinkai'
    },
    '/impact-on-the-economy': {
        lv: '/ietekme-uz-ekonomiku',
        lt: '/poveikis-ekonomikai'
    },
    '/impact-on-society': {
        lv: '/ietekme-uz-sabiedribu',
        lt: '/poveikis-visuomenei'
    },
    '/news/post/wood-for-energy-markets': {
        lv: '/energetiskas-koksnes-sertifikacija',
        en: '/wood-for-energy-markets',
    },
    '/news/post/rebranding': {
        en: '/rebranding',
        lv: '/zimola-maina'
    },
    '/news/post/landscaping-project': {
        lv: '/apmezosanas-projekts',
    },
    '/news/post/sbp-biomass-certification': {
        lv: '/sbp-biomasas-sertifikacija',
    },
    '/news/archive/2020': {
        lv: '/2020',
        en: '/2020',
        cn: '/2020',
        lt: '/2020',
    },
    '/news/archive/2025': {
        lv: '/2025',
        en: '/2025',
        cn: '/2025',
        lt: '/2025',
    },
    '/wood-sawmill': {
        lv: '/kokzagetava'
    },
    '/information-for-shareholders': {
        lv: '/informacija-akcionariem'
    },
    '/round-timber-procurement': {
        lv: '/apalkoku-iepirksana'
    },
    '/timber-stand-procurement': {
        lv: '/cirsmu-iepirksana'
    }
} as const;